
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industries/chemical/products/chemical-inventory-management-systems",
      function () {
        return require("private-next-pages/industries/chemical/products/chemical-inventory-management-systems.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industries/chemical/products/chemical-inventory-management-systems"])
      });
    }
  